<template>
  <el-container class="layout">
    <el-header style="height: 315px;">
      <header-vue></header-vue>
    </el-header>
    <el-main>
      <router-view></router-view>
    </el-main>
    <el-footer>
      <footer-vue></footer-vue>
    </el-footer>
  </el-container>
</template>

<script>
import FooterVue from "./component/FooterVue.vue";
import HeaderVue from "./component/HeaderVue";

export default {
  name: "layOut",
  components: {
    HeaderVue,
    FooterVue,
  },
};
</script>

<style lang="less" scoped >
/deep/ .el-main {
  // scrollbar-width: none; /* For Firefox */
  // -ms-overflow-style: none; /* For Internet Explorer and Edge */
  // overflow: -moz-scrollbars-none; /* For Firefox */
  // overflow: scroll; /* 确保内容可以滚动 */
  // overflow: hidden;
  min-height: calc(~"100vh - 130px");
  padding: 0;
  background-color: transparent;
  top: -90px;
  z-index: 9999999999999;
  position: relative;
}
/deep/ .el-main::-webkit-scrollbar {
  display: none;
}
/deep/ .el-header {
  // background-color: #f6f9ff;
  // position: sticky;
  z-index: 1000;
  top: 0;
  padding: 0 !important;
  // box-shadow: 0px 0px 9px 0px rgba(124,124,124,0.25);
}
/deep/ .el-footer {
  padding: 0 !important;
  height: 70px !important;
}
</style>